const banners = Array.from(
    document.querySelectorAll<HTMLElement>('.apprenticeship-banner'),
);

if (banners.length > 1) {
    const track = document.createElement('div');
    track.className = 'apprenticeship-banner-track';
    banners[0].parentNode!.insertBefore(track, banners[0]);
    banners.forEach((b) => track.appendChild(b));
}
